module.exports = __webpack_public_path__ + "img/Play_Button.5dbfc85a.svg";